import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { navigateToDashboard } from '../../utils/roleNavigation';

/**
 * Pagina generica di errore che può essere utilizzata per vari tipi di errori
 * Supporta parametri passati tramite state per personalizzare il messaggio
 */
const ErrorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // Estrai i parametri dall'oggetto state (se presenti)
  const errorCode = location.state?.errorCode || '500';
  const errorTitle = location.state?.errorTitle || 'Errore del Server';
  const errorMessage = location.state?.errorMessage || 
    'Si è verificato un errore imprevisto. Riprova più tardi.';
  const errorDetails = location.state?.errorDetails;

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    if (user) {
      navigateToDashboard(navigate, user.role);
    } else {
      navigate('/');
    }
  };

  // Determina il colore e l'icona in base al tipo di errore
  const getErrorStyle = (code) => {
    const numCode = parseInt(code);
    if (numCode >= 400 && numCode < 500) {
      return { color: 'warning', icon: 'bi-exclamation-circle' };
    } else if (numCode >= 500) {
      return { color: 'danger', icon: 'bi-x-octagon' };
    }
    return { color: 'secondary', icon: 'bi-exclamation-triangle' };
  };

  const errorStyle = getErrorStyle(errorCode);

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Row className="w-100">
        <Col md={8} lg={6} className="mx-auto">
          <Card className="shadow-lg border-0">
            <Card.Body className="text-center p-5">
              <div className="mb-4">
                <i className={`bi ${errorStyle.icon} text-${errorStyle.color}`} style={{ fontSize: '5rem' }}></i>
              </div>
              
              <h1 className={`display-4 fw-bold text-${errorStyle.color} mb-3`}>{errorCode}</h1>
              <h2 className="mb-4">{errorTitle}</h2>
              
              <p className="text-muted mb-4">
                {errorMessage}
              </p>

              {errorDetails && (
                <div className="alert alert-light mb-4">
                  <small className="text-muted">
                    <i className="bi bi-info-circle me-2"></i>
                    {errorDetails}
                  </small>
                </div>
              )}

              <p className="text-muted mb-4">
                Se il problema persiste, contatta l'assistenza tecnica.
              </p>

              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <Button variant="outline-secondary" onClick={handleGoBack}>
                  <i className="bi bi-arrow-left me-2"></i>
                  Torna Indietro
                </Button>
                <Button variant="primary" onClick={handleGoHome}>
                  <i className="bi bi-house-door me-2"></i>
                  {user ? 'Vai alla Dashboard' : 'Vai alla Home'}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorPage;
